import React, { useMemo, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { FieldArray, Form, Formik } from "formik";
import { useSession } from "../../authentications/SessionContext";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import FormikInput from "../Formik/FormikInput";
import cameraIcon from "../../Images/camera.svg";
import ErrorFocus from "../Formik/ErrorFocus";
import General from "./NavtabsComponents/General/General";
import Branches from "./NavtabsComponents/Branches/Branches";
import SVGButton from "../../Components/Buttons/SVGButton";
import editIcon from "../../Images/edit.svg";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import {
  BANk_LINE_DETAIL_KEYS,
  COMPANY_DETAIL_KEYS,
  ACTIVE_SOCIAL_MEDIA_KEYS,
  CONTRACT_LINE_DETAIL_KEYS,
  USER_LINE_DETAIL_KEYS,
} from "../../utilities/constants";
import { onChangeCompany } from "../../DataApi/Company/onChangeCompany";
import { create } from "../../DataApi/create";
import { read } from "../../DataApi/read";
import { write } from "../../DataApi/write";
import { newCompanyValidationSchema } from "../../utilities/Validation Schema/newCompanyValidationSchema";
import BankAccountCR from "../ContactsComponents/ContactsModals/BankInformation";
import useListOptions from "../../CustomHooks/useListOptions";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import { getFormattedList } from "../../utilities/getFormtattedList";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import { load_views_company } from "../../DataApi/load_views";
import { object } from "yup";
import { handleResponse } from "../../utilities/handleResponse";
import useConfirmationModal from "../ConfirmationModal/useConfirmationModal";
import VtexIntegration from "./VtexTab/VtexIntegration";
import { primaryColor } from "../../utilities/colors";
import BankInformation from "../ContactsComponents/ContactsModals/BankInformation";
import Documents from "../ContactsComponents/ContactsModals/Documents";
import SignatureComponent from "./SignatureComponent/SignatureComponent";
import ManualContract from "./ManualContract/ManualContract";
import ContactDetails from "./ContactDetails/ContactDetails";
import { checkApi } from "../../DataApi/onboarding/checkApi";
import VtexGeneral from "./VtexGeneral/VtexGeneral";
import { enqueueSnackbar } from "notistack";

const Button = styled.button`
  background-color: #cbcbcb;
  color: #535559;
  width: 280px;
  min-width: 160px;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter";
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;
const ImageContainer = styled.div`
  border-radius: 10px;
  background-color: #fff;
  border: 1px solid #cbcbcb;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 193px;
  height: 175px;
  margin-bottom: 20px;
  overflow: hidden;
`;

const AddNewCompany = ({ selectedRecord = {}, handleCloseModal }) => {
  const {
    ConfirmationModal,
    setMetaData,
    setTitle,
    setOpenModal,
    toggleModal,
  } = useConfirmationModal();
  const { setIsSubmitting, FormikSubmitButtons } = useFormikSubmitButton();
  const {
    options: stateList,
    setOptions: setStateList,
    handleCustomSearch,
  } = useListOptions();

  const [modalType, setModalType] = useState("add");
  const { sessionInfo } = useSession();
  const {
    company_id,
    context,
    user_id,
    isVTEX,
    is_vtex_admin,
    is_vtex_omantal,
  } = sessionInfo;
  const [isLoading, setIsLoading] = useState(true);
  const { language, translations } = useLanguage();
  const t = translations[language];
  const logoRef = useRef();
  const [activeTab, setActiveTab] = useState(0);
  const [bankList, setBankList] = useState([]);
  const [isManualContract, setIsManualContract] = useState(false);
  const [counryList, setCounryList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [sellerGroup, setSellerGroup] = useState([]);
  const [mailTemplateList, setmailTemplateList] = useState([]);
  const [billingCountryList, setBillingCountryList] = useState([]);
  const [billingGovernateList, setBillingGovernateList] = useState([]);
  const [billingWilayatList, setBillingWilayatList] = useState([]);
  const [billingCityList, setBillingCityList] = useState([]);
  const [billingAreaList, setBillingAreaList] = useState([]);
  const [billingZipList, setBillingZipList] = useState([]);
  const [pickupCountryList, setPickupCountryList] = useState([]);
  const [pickupGovernateList, setPickupGovernateList] = useState([]);
  const [pickupWilayatList, setPickupWilayatList] = useState([]);
  const [pickupCityList, setPickupCityList] = useState([]);
  const [pickupAreaList, setPickupAreaList] = useState([]);
  const [pickupZipList, setPickupZipList] = useState([]);
  const [isVtexInvitationConnected, setIsVtexInvitationConnected] =
    useState(false);
  // const [base64Signature, setBase64Signature] = useState("");

  // const [activeSocialMediaList, setactiveSocialMediaList] = useState([]);
  const [inputs, setInputs] = useState({
    active_social_media_lines: [],
    bank_ids: [],
    manual_contract_id: [],
    associated_user_ids: [],
    // branches: [],
    // car_parts: false,
    city: false,
    company_registry: false,
    connected: false,
    country_code: false,
    country_id: false,
    governorate_id: false,
    wilayat_id: false,
    city_id: false,
    area_id: false,
    s_country_id: false,
    s_governorate_id: false,
    s_wilayat_id: false,
    s_city_id: false,
    s_area_id: false,
    currency_id: "",
    email: false,
    enable_contact_map_support: false,
    facebook_analytics: false,
    favicon: "",
    instagram_analytics: false,
    logo: "",
    digital_signature: "",
    name: "",
    business_name: "",
    parent_id: false,
    partner_id: false,
    phone: false,
    s_phone: false,
    sales_notify_template_id: false,
    sequence: 10,
    social_facebook: false,
    social_github: false,
    social_instagram: false,
    social_linkedin: false,
    social_twitter: false,
    social_youtube: false,
    state_id: false,
    street: false,
    street2: false,
    subscription_id: [],
    twitter_analytics: false,
    vat: false,
    is_vtex: false,
    vtex_status: "pending",
    VtexWarehouse: false,
    vtexSellerGroup: false,
    vtexSellerGroupTax: false,
    VtexInvitationId: false,
    vtex_invitation: false,
    vtex_appkey: false,
    vtex_api_token: false,
    VtexAccountName: false,
    website: false,
    zip: false,
    zip_id: false,
    s_zip_id: false,
    __last_update: false,
  });
  const [previousInputs, setPreviousInputs] = useState({});

  const getPayload = (newInputs) => {
    const bankIds = getFormattedList(newInputs.bank_ids, "id", [
      "bank",
      "isDeleted",
    ]);
    const manualContractIds = getFormattedList(
      newInputs.manual_contract_id,
      "id",
      ["contract", "isDeleted"]
    );
    const userIds = getFormattedList(newInputs.associated_user_ids, "id", [
      "user",
      "isDeleted",
    ]);
    const mediaLines = newInputs?.active_social_media_lines?.map((social) => [
      1,
      social.id,
      { selected: social.selected },
    ]);
    const payload = {
      active_social_media_lines: mediaLines || [],
      bank_ids: bankIds || [],
      manual_contract_id: manualContractIds || [],
      associated_user_ids: userIds || [],
      city: newInputs?.city || false,
      company_registry: newInputs?.company_registry || false,
      connected: newInputs?.connected || false,
      country_code: newInputs?.country_code || false,
      country_id: newInputs?.country_id || false,
      governorate_id: newInputs?.governorate_id || false,
      wilayat_id: newInputs?.wilayat_id || false,
      city_id: newInputs?.city_id || false,
      area_id: newInputs?.area_id || false,
      s_country_id: newInputs?.s_country_id || false,
      s_governorate_id: newInputs?.s_governorate_id || false,
      s_wilayat_id: newInputs?.s_wilayat_id || false,
      s_city_id: newInputs?.s_city_id || false,
      s_area_id: newInputs?.s_area_id || false,
      currency_id: newInputs?.currency_id || false,
      email: newInputs?.email || false,
      enable_contact_map_support:
        newInputs?.enable_contact_map_support || false,
      facebook_analytics: newInputs?.facebook_analytics || false,
      favicon: newInputs?.favicon || "",
      instagram_analytics: newInputs?.instagram_analytics || false,
      logo: newInputs?.logo || "",
      digital_signature: newInputs?.digital_signature || "",
      name: newInputs?.name || false,
      business_name: newInputs?.business_name || false,
      parent_id: newInputs?.parent_id || false,
      partner_id: newInputs?.partner_id || false,
      phone: newInputs?.phone || false,
      s_phone: newInputs?.s_phone || false,
      sales_notify_template_id: newInputs?.sales_notify_template_id || false,
      sequence: newInputs?.sequence || 10,
      social_facebook: newInputs?.social_facebook || false,
      social_github: newInputs?.social_github || false,
      social_instagram: newInputs?.social_instagram || false,
      social_linkedin: newInputs?.social_linkedin || false,
      social_twitter: newInputs?.social_twitter || false,
      social_youtube: newInputs?.social_youtube || false,
      state_id: newInputs?.state_id || false,
      street: newInputs?.street || false,
      street2: newInputs?.street2 || false,
      subscription_id: newInputs?.subscription_id || [],
      twitter_analytics: newInputs?.twitter_analytics || false,
      vat: newInputs?.vat || false,
      is_vtex: newInputs?.is_vtex || false,
      vtex_status: newInputs?.vtex_status || "pending",
      VtexWarehouse: newInputs?.VtexWarehouse || false,
      vtexSellerGroup: newInputs?.vtexSellerGroup || false,
      vtexSellerGroupTax: newInputs?.vtexSellerGroupTax || false,
      VtexInvitationId: newInputs?.VtexInvitationId || false,
      vtex_invitation: newInputs?.vtex_invitation || false,
      vtex_appkey: newInputs?.vtex_appkey || false,
      vtex_api_token: newInputs?.vtex_api_token || false,
      VtexAccountName: newInputs?.VtexAccountName || false,
      website: newInputs?.website || false,
      zip: newInputs?.zip || false,
      zip_id: newInputs?.zip_id || false,
      s_zip_id: newInputs?.s_zip_id || false,
      __last_update: newInputs?.__last_update || false,
    };
    return payload;
  };
  const handleChangeimage1920 = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => setFieldValue("logo", base64));
    }
  };
  const handleEditCompany = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(inputs);
    const newPayload = getPayload(values);
    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) != JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges)?.length === 0) return handleCloseModal();
    let response = await write({
      id: selectedRecord?.id,
      change: newChanges,
      company_id,
      context,
      model: "res.company",
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
      return false;
    }

    return response;
  };
  const handleAddNewCompany = async (values) => {
    const payload = getPayload(values);
    // return
    let response = await create({
      payload,
      context,
      company_id,
      model: "res.company",
      options: {},
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
      return false;
    }
    return response;
  };
  const handleNavigationItemClick = (tabIndex, e) => {
    e.preventDefault();
    e.stopPropagation(); // Stop event propagation
    setActiveTab(tabIndex);
  };
  const handleSubmitType = async (...args) => {
    setIsSubmitting(true);
    let response = {};
    let successMessage = "Company Created Successfully";

    if (modalType === "edit") {
      successMessage = "Company Edited Successfully";
      response = await handleEditCompany(...args);
      // console.log("Response from handleEditForm:", response);
    } else if (modalType === "add") {
      response = await handleAddNewCompany(...args);
      // console.log("Response from handleAddCompany:", response);
    }
    setIsSubmitting(false);
    toggleModal();
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
  };
  const fetchCompanyDetails = async () => {
    if (!selectedRecord?.id) return false;

    let response = await read({
      id: selectedRecord?.id,
      change: [],
      context,
      company_id,
      model: "res.company",
    });
    response = JSON.parse(response);
    setIsManualContract(
      response?.result?.[0].manual_contract_id?.length > 0 ? true : false
    );
    // console.log("isManualContract", isManualContract);
    if (response?.result?.[0]) {
      // console.log("company resp", response?.result?.[0]?.vtex_invitation);
      if (response?.result?.[0]?.vtex_invitation === "Connected") {
        setIsVtexInvitationConnected(true);
      } else {
        setIsVtexInvitationConnected(false);
      }
      const promisesList = [];
      if (response?.result?.[0]?.active_social_media_lines.length > 0) {
        promisesList.push(
          read({
            id: response?.result?.[0]?.active_social_media_lines,
            change: [],
            context,
            company_id,
            model: "company.active.social.media",
          })
        );
      }
      if (response?.result?.[0]?.bank_ids?.length > 0) {
        promisesList.push(
          read({
            id: response?.result?.[0].bank_ids,
            company_id,
            context,
            change: BANk_LINE_DETAIL_KEYS,
            model: "res.partner.bank",
          })
        );
      }

      if (response?.result?.[0]?.manual_contract_id?.length > 0) {
        promisesList.push(
          read({
            id: response?.result?.[0].manual_contract_id,
            company_id,
            context,
            change: CONTRACT_LINE_DETAIL_KEYS,
            model: "vtex.manual.contract.lines",
          })
        );
      }
      if (response?.result?.[0]?.associated_user_ids?.length > 0) {
        promisesList.push(
          read({
            id: response?.result?.[0].associated_user_ids,
            company_id,
            context,
            change: USER_LINE_DETAIL_KEYS,
            model: "res.users",
          })
        );
      }

      // console.log("promiseList", promisesList);
      const promiseResponse = await Promise.all([...promisesList]);
      // console.log("promiseResponse", promiseResponse);
      const parsedResults = promiseResponse.map((result) => JSON.parse(result));
      // console.log("first", parsedResults);
      const errorResult = parsedResults.find((res) => res.error);

      if (errorResult) {
        // Display error message in the Snackbar and exit early
        enqueueSnackbar(errorResult.error.data.message || "An error occurred", {
          variant: "error",
          persist: false,
        });
        handleCloseModal();
        return; // Exit the function on error
      }
      // Initialize variables to track responses.
      let currentIndex = 0;

      let socialResponse,
        bankLineResponse,
        contractLineResponse,
        userLineResponse;

      // 1. Check if active_social_media_lines exist and assign response if true.
      if (response?.result?.[0]?.active_social_media_lines?.length > 0) {
        socialResponse = JSON.parse(promiseResponse[currentIndex]);
        response = {
          ...response,
          result: [
            {
              ...response.result[0],
              active_social_media_lines: socialResponse?.result || [],
            },
          ],
        };
        currentIndex++; // Move to the next promise response.
      }

      // 2. Check if bank_ids exist and assign response if true.
      let bank_lines = [];
      const banks = [];
      if (response?.result?.[0]?.bank_ids?.length > 0) {
        bankLineResponse = JSON.parse(promiseResponse[currentIndex]);
        bank_lines = bankLineResponse.result.map((item) => {
          banks.push(item.bank_id);
          return {
            ...item,
            acc_holder_name: item?.acc_holder_name || false,
            acc_number: item?.acc_number || false,
            bank_id: item?.bank_id?.[0] || false,
            bank: item?.bank_id || false,
            branch_name: item?.branch_name || false,
            cr_img: item?.cr_img || false,
            vc_img: item?.vc_img || false,
            cc_img: item?.cc_img || false,
            cr_number: item?.cr_number || false,
            cr_expiry_date: item?.cr_expiry_date || false,
            vat_number: item?.vat_number || false,
            vat_expiry_date: item?.vat_expiry_date || false,
            sequence: item?.sequence || 10,
            isDeleted: false,
          };
        });
        currentIndex++; // Move to the next promise response.
      }

      // 3. Check if manual_contract_id exist and assign response if true.
      let contract_lines = [];
      const contracts = [];
      if (response?.result?.[0]?.manual_contract_id?.length > 0) {
        contractLineResponse = JSON.parse(promiseResponse[currentIndex]);
        contract_lines = contractLineResponse.result.map((item) => {
          contracts.push(item.id);
          return {
            ...item,
            attachment_id: item?.attachment_id || false,
            contract_status: item?.contract_status || false,
            date_start: item?.date_start || false,
            id: item?.id || false,
            isDeleted: false,
          };
        });
        currentIndex++; // Move to the next promise response.
      }

      // 4. Check if associated_user_ids exist and assign response if true.
      let user_lines = [];
      const users = [];
      if (response?.result?.[0]?.associated_user_ids?.length > 0) {
        userLineResponse = JSON.parse(promiseResponse[currentIndex]);
        user_lines = userLineResponse.result.map((item) => {
          users.push(item.id);
          return {
            ...item,
            name: item?.name || false,
            email: item?.login || false,
            designation: item?.designation || false,
            phone: item?.phone || false,
            id: item?.id || false,
            isDeleted: false,
          };
        });
        currentIndex++; // Move to the next promise response.
      }

      // Debugging Logs to Verify Correct Assignment.
      // console.log("socialResponse", socialResponse);
      // console.log("bankLineResponse", bankLineResponse);
      // console.log("contractLineResponse", contractLineResponse);
      // console.log("userLineResponse", userLineResponse);

      const responseData = response?.result?.[0];
      const inputsList = {
        ...inputs,
        ...responseData,
        active_social_media_lines:
          responseData?.active_social_media_lines || [],
        bank_ids: bank_lines || [],
        manual_contract_id: contract_lines || [],
        associated_user_ids: user_lines || [],
        currency_id: responseData?.currency_id?.[0] || "",
        favicon: responseData?.favicon || "",
        logo: responseData?.logo || "",
        digital_signature: responseData?.digital_signature || "",
        subscription_id: responseData?.subscription_id?.[0] || "",
        country_id: responseData?.country_id?.[0] || "",
        governorate_id: responseData?.governorate_id?.[0] || "",
        wilayat_id: responseData?.wilayat_id?.[0] || "",
        city_id: responseData?.city_id?.[0] || "",
        area_id: responseData?.area_id?.[0] || "",
        zip_id: responseData?.zip_id?.[0] || "",
        s_country_id: responseData?.s_country_id?.[0] || "",
        s_governorate_id: responseData?.s_governorate_id?.[0] || "",
        s_wilayat_id: responseData?.s_wilayat_id?.[0] || "",
        s_city_id: responseData?.s_city_id?.[0] || "",
        s_area_id: responseData?.s_area_id?.[0] || "",
        s_zip_id: responseData?.s_zip_id?.[0] || "",
        zip: responseData?.zip || "",
        state_id: responseData?.state_id?.[0] || "",
        phone: responseData?.phone || false,
        s_phone: responseData?.s_phone || false,
        sales_notify_template_id:
          responseData?.sales_notify_template_id?.[0] || false,
        vat: responseData?.vat || false,
        is_vtex: responseData?.is_vtex || false,
        vtex_status: responseData?.vtex_status || "pending",
        VtexWarehouse: responseData?.VtexWarehouse || false,
        vtexSellerGroup: responseData?.vtexSellerGroup || false,
        vtexSellerGroupTax: responseData?.vtexSellerGroupTax || false,
        VtexInvitationId: responseData?.VtexInvitationId || false,
        vtex_invitation: responseData?.vtex_invitation || false,
        vtex_appkey: responseData?.vtex_appkey || false,
        vtex_api_token: responseData?.vtex_api_token || false,
        VtexAccountName: responseData?.VtexAccountName || false,
        street: responseData?.street || false,
        street2: responseData?.street2 || false,
        city: responseData?.city || false,

        // extra fileds but need them
        additionalOptions: {
          state: responseData?.state_id || null,
          country: responseData?.country_id || null,
          billingCountry: responseData?.s_country_id || null,
          billingGovernate: responseData?.s_governorate_id || null,
          billingWilayat: responseData?.s_wilayat_id || null,
          billingCity: responseData?.s_city_id || null,
          billingArea: responseData?.s_area_id || null,
          billingZip: responseData?.s_zip_id || null,
          pickupCountry: responseData?.country_id || null,
          pickupGovernate: responseData?.governorate_id || null,
          pickupWilayat: responseData?.wilayat_id || null,
          pickupCity: responseData?.city_id || null,
          pickupArea: responseData?.area_id || null,
          pickupZip: responseData?.zip_id || null,
          currency: responseData?.currency_id || null,
          vtexSellerGroup: responseData?.vtexSellerGroup || null,
          vtexSellerGroupTax: responseData?.vtexSellerGroupTax || null,
          sales_notify_template: responseData?.sales_notify_template_id || null,
          bank: banks,
        },
      };
      setPreviousInputs(inputsList);
      setInputs(inputsList);
      return inputsList;
    }
    return false;
  };
  const getOnChange = async () => {
    let onChangeResp = await onChangeCompany({ context, company_id });
    onChangeResp = JSON.parse(onChangeResp);
    setInputs((prevInputs) => ({
      ...prevInputs,
      currency_id:
        onChangeResp?.result?.value?.currency_id?.[0] || prevInputs.currency_id,
    }));
    setIsLoading(false);
  };
  // const handleChangeCountry = (value) => {
  //   checkApi({
  //     endpoint: "/onboarding/governorate",
  //     params: {
  //       country_id: value,
  //     },
  //   }).then((governates) => {
  //     if (governates?.result?.result?.length > 0) {
  //       const governateOp = governates?.result?.result?.map((item) => ({
  //         label: item.name,
  //         value: item.id,
  //       }));
  //       setGovernateOption(governateOp || []);
  //     }
  //   });
  // };
  // const onChangeGovernate = (value) => {
  //   checkApi({
  //     endpoint: "/onboarding/wilayat",
  //     params: {
  //       governorate_id: value,
  //     },
  //   }).then((wilayats) => {
  //     if (wilayats?.result?.result?.length > 0) {
  //       const wilayatOp = wilayats?.result?.result?.map((item) => ({
  //         label: item.name,
  //         value: item.id,
  //       }));
  //       setWilayatOption(wilayatOp || []);
  //     }
  //   });
  // };
  // const onChangeWilayat = (value) => {
  //   checkApi({
  //     endpoint: "/onboarding/city",
  //     params: {
  //       wilayat_id: value,
  //     },
  //   }).then((cities) => {
  //     if (cities?.result?.result?.length > 0) {
  //       const cityOp = cities?.result?.result?.map((item) => ({
  //         label: item.name,
  //         value: item.id,
  //       }));
  //       setCityOption(cityOp || []);
  //     }
  //   });
  // };
  // const onChangeCity = (value) => {
  //   checkApi({
  //     endpoint: "/onboarding/area",
  //     params: {
  //       city_id: value,
  //     },
  //   }).then((areas) => {
  //     if (areas?.result?.result?.length > 0) {
  //       const areaOp = areas?.result?.result?.map((item) => ({
  //         label: item.name,
  //         value: item.id,
  //       }));
  //       setAreaOption(areaOp || []);
  //     }
  //   });
  // };

  useEffect(() => {
    if (selectedRecord?.id) {
      setModalType("view");
      fetchCompanyDetails().then((response) => {
        setIsLoading(false);
        if (!response) return;
        // console.log("seller group", response);
        const {
          bank: companybanks = [],
          state = null,
          country = null,
          billingCountry = null,
          billingGovernate = null,
          billingWilayat = null,
          billingCity = null,
          billingArea = null,
          billingZip = null,
          pickupCountry = null,
          pickupGovernate = null,
          pickupWilayat = null,
          pickupCity = null,
          pickupArea = null,
          pickupZip = null,
          currency = null,
          sellerGroup = null,
          sales_notify_template = null,
        } = response?.additionalOptions || {};
        // console.log(
        //   "country,governate,wilayat,city,area,zip for billing",
        //   billingCountry,
        //   billingGovernate,
        //   billingWilayat,
        //   billingCity,
        //   billingArea,
        //   billingZip
        // );
        findAndAddOption({
          incomingOption: billingCountry,
          setAvailableOptions: setBillingCountryList,
        });
        findAndAddOption({
          incomingOption: billingGovernate,
          setAvailableOptions: setBillingGovernateList,
        });
        findAndAddOption({
          incomingOption: billingWilayat,
          setAvailableOptions: setBillingWilayatList,
        });
        findAndAddOption({
          incomingOption: billingCity,
          setAvailableOptions: setBillingCityList,
        });
        findAndAddOption({
          incomingOption: billingArea,
          setAvailableOptions: setBillingAreaList,
        });
        findAndAddOption({
          incomingOption: billingZip,
          setAvailableOptions: setBillingZipList,
        });
        findAndAddOption({
          incomingOption: pickupCountry,
          setAvailableOptions: setPickupCountryList,
        });
        findAndAddOption({
          incomingOption: pickupGovernate,
          setAvailableOptions: setPickupGovernateList,
        });
        findAndAddOption({
          incomingOption: pickupWilayat,
          setAvailableOptions: setPickupWilayatList,
        });
        findAndAddOption({
          incomingOption: pickupCity,
          setAvailableOptions: setPickupCityList,
        });
        findAndAddOption({
          incomingOption: pickupArea,
          setAvailableOptions: setPickupAreaList,
        });
        findAndAddOption({
          incomingOption: pickupZip,
          setAvailableOptions: setPickupZipList,
        });

        companybanks?.forEach((bank) => {
          findAndAddOption({
            incomingOption: bank,
            setAvailableOptions: setBankList,
          });
        });
        findAndAddOption({
          incomingOption: state,
          setAvailableOptions: setStateList,
        });
        findAndAddOption({
          incomingOption: country,
          setAvailableOptions: setCounryList,
        });
        findAndAddOption({
          incomingOption: currency,
          setAvailableOptions: setCurrencyList,
        });
        findAndAddOption({
          incomingOption: sellerGroup,
          setAvailableOptions: setSellerGroup,
        });
        findAndAddOption({
          incomingOption: sales_notify_template,
          setAvailableOptions: setmailTemplateList,
        });
      });
    } else {
      setModalType("add");
      getOnChange();
    }
  }, [selectedRecord]);

  useEffect(() => {
    if (modalType === "edit" && inputs) {
      const {
        bank: companybanks = [],
        state = null,
        country = null,
        billingCountry = null,
        billingGovernate = null,
        billingWilayat = null,
        billingCity = null,
        billingArea = null,
        billingZip = null,
        pickupCountry = null,
        pickupGovernate = null,
        pickupWilayat = null,
        pickupCity = null,
        pickupArea = null,
        pickupZip = null,
        currency = null,
        sellerGroup = null,
        sales_notify_template = null,
      } = inputs?.additionalOptions || {};

      // checkApi({
      //   endpoint: "/onboarding/governorate",
      //   params: {
      //     country_id: pickupCountry[0],
      //   },
      // }).then((wilayats) => {
      //   if (wilayats?.result?.result?.length > 0) {
      //     const wilayatOp = wilayats?.result?.result?.map((item) => ({
      //       label: item.name,
      //       value: item.id,
      //       // zip: theme.zip,
      //     }));
      //     setPickupGovernateList(wilayatOp || []);
      //   }
      // });
      // checkApi({
      //   endpoint: "/onboarding/wilayat",
      //   params: {
      //     governorate_id: pickupGovernate[0],
      //   },
      // }).then((wilayats) => {
      //   if (wilayats?.result?.result?.length > 0) {
      //     const wilayatOp = wilayats?.result?.result?.map((item) => ({
      //       label: item.name,
      //       value: item.id,
      //       // zip: theme.zip,
      //     }));
      //     setPickupWilayatList(wilayatOp || []);
      //   }
      // });
      // checkApi({
      //   endpoint: "/onboarding/City",
      //   params: {
      //     wilayat_id: pickupWilayat[0],
      //   },
      // }).then((wilayats) => {
      //   if (wilayats?.result?.result?.length > 0) {
      //     const wilayatOp = wilayats?.result?.result?.map((item) => ({
      //       label: item.name,
      //       value: item.id,
      //       // zip: theme.zip,
      //     }));
      //     setPickupCityList(wilayatOp || []);
      //   }
      // });

      handleCustomSearch({
        model: "res.country",
        setState: setBillingCountryList,
        staticOptions: billingCountry ? [billingCountry] : [],
      });
      handleCustomSearch({
        model: "governorate.master",
        setState: setBillingGovernateList,
        staticOptions: billingGovernate ? [billingGovernate] : [],
      });
      handleCustomSearch({
        model: "wilayat.master",
        setState: setBillingWilayatList,
        staticOptions: billingWilayat ? [billingWilayat] : [],
      });
      handleCustomSearch({
        model: "city.master",
        setState: setBillingCityList,
        staticOptions: billingCity ? [billingCity] : [],
      });
      handleCustomSearch({
        model: "area.master",
        setState: setBillingAreaList,
        staticOptions: billingArea ? [billingArea] : [],
      });
      handleCustomSearch({
        model: "zip.master",
        setState: setBillingZipList,
        staticOptions: billingZip ? [billingZip] : [],
      });
      handleCustomSearch({
        model: "res.country",
        setState: setPickupCountryList,
        staticOptions: pickupCountry ? [pickupCountry] : [],
      });
      handleCustomSearch({
        model: "governorate.master",
        setState: setPickupGovernateList,
        staticOptions: pickupGovernate ? [pickupGovernate] : [],
      });
      handleCustomSearch({
        model: "wilayat.master",
        setState: setPickupWilayatList,
        staticOptions: pickupWilayat ? [pickupWilayat] : [],
      });
      handleCustomSearch({
        model: "city.master",
        setState: setPickupCityList,
        staticOptions: pickupCity ? [pickupCity] : [],
      });
      handleCustomSearch({
        model: "area.master",
        setState: setPickupAreaList,
        staticOptions: pickupArea ? [pickupArea] : [],
      });
      handleCustomSearch({
        model: "zip.master",
        setState: setPickupZipList,
        staticOptions: pickupZip ? [pickupZip] : [],
      });
      handleCustomSearch({
        model: "res.bank",
        setState: setBankList,
        staticOptions: companybanks || [],
      });
      handleCustomSearch({
        model: "res.country.state",
        setState: setStateList,
        staticOptions: state ? [state] : [],
      });
      handleCustomSearch({
        model: "res.country",
        setState: setCounryList,
        staticOptions: country ? [country] : [],
      });
      handleCustomSearch({
        model: "res.currency",
        setState: setCurrencyList,
        staticOptions: currency ? [currency] : [],
      });
      handleCustomSearch({
        model: "res.company",
        setState: setSellerGroup,
        staticOptions: sellerGroup ? [sellerGroup] : [],
      });
      handleCustomSearch({
        model: "mail.template",
        setState: setmailTemplateList,
        staticOptions: sales_notify_template ? [sales_notify_template] : [],
      });
    }
  }, [modalType, inputs]);

  const disableInputs = useMemo(() => modalType === "view", [modalType]);
  return (
    <>
      <ConfirmationModal />
      <Formik
        enableReinitialize
        initialValues={inputs}
        validationSchema={newCompanyValidationSchema}
        onSubmit={handleSubmitType}
      >
        {({
          values,
          setFieldValue,
          validateForm,
          setErrors,
          setFieldTouched,
        }) => (
          <Form>
            <div
              className="container"
              style={{ maxWidth: "900px", padding: "10px" }}
            >
              {/* {console.log({ values, inputs }, "  ")} */}
              <FormContainer className="row g-3">
                <div className="d-flex">
                  <h3 className="modal-title mb-2">
                    {modalType === "add" && t["Add Company"]}
                    {modalType === "edit" && t["Edit Company"]}
                    {modalType === "view" && t["Company"]}
                  </h3>
                  {modalType === "view" && (
                    <div className="col d-flex justify-content-end p-0">
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        icon={editIcon}
                        onClick={() => {
                          setModalType("edit");
                        }}
                        className="me-2"
                      />
                    </div>
                  )}
                </div>
                <hr />
                <LoaderWrapper
                  isLoading={isLoading}
                  height="50vh"
                  width="800px"
                >
                  <div className="row p-0 justify-content-between align-items-center">
                    <div className="d-flex flex-column flex-md-row gap-3">
                      <div className="d-flex flex-column  col-12 col-md-8">
                        <div className="d-flex flex-column">
                          <div className="col-12">
                            <FormikInput
                              disabled={disableInputs}
                              name="name"
                              label={t["Store Name"] + "*"}
                            />
                          </div>
                          <div className="col-12">
                            <FormikInput
                              disabled={disableInputs}
                              name="business_name"
                              label={t["Legal Business Name"] + "*"}
                            />
                          </div>
                        </div>
                      </div>
                      <ImageContainer
                        className="ms-4"
                        onClick={() => {
                          if (!disableInputs) logoRef.current.click();
                        }}
                      >
                        <UploadedImage src={values.logo || cameraIcon} />
                        <input
                          ref={logoRef}
                          type="file"
                          name="logo"
                          hidden
                          onChange={(e) =>
                            handleChangeimage1920(e, setFieldValue)
                          }
                        />
                      </ImageContainer>
                    </div>
                  </div>

                  <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                      <button
                        className={`nav-link vtex-company-nav-link${
                          activeTab === 0 ? "active" : ""
                        }`}
                        onClick={(e) => handleNavigationItemClick(0, e)}
                      >
                        {t["General"]}
                      </button>
                      <button
                        className={`nav-link vtex-company-nav-link${
                          activeTab === 1 ? "active" : ""
                        }`}
                        onClick={(e) => handleNavigationItemClick(1, e)}
                      >
                        {isVTEX
                          ? t["Bank Information"]
                          : t["Bank Account and CR"]}
                      </button>
                      {isVTEX && (
                        <button
                          className={`nav-link vtex-company-nav-link${
                            activeTab === 2 ? "active" : ""
                          }`}
                          onClick={(e) => handleNavigationItemClick(2, e)}
                        >
                          {t["Documents"]}
                        </button>
                      )}
                      {isVTEX && is_vtex_admin && is_vtex_omantal && (
                        <button
                          className={`nav-link vtex-company-nav-link${
                            activeTab === 3 ? "active" : ""
                          }`}
                          onClick={(e) => handleNavigationItemClick(3, e)}
                        >
                          {t["VTEX Integration"]}
                        </button>
                      )}
                      {isVTEX && (
                        <button
                          className={`nav-link vtex-company-nav-link${
                            activeTab === 4 ? "active" : ""
                          }`}
                          onClick={(e) => handleNavigationItemClick(4, e)}
                        >
                          {t["Contact Details"]}
                        </button>
                      )}
                      {isVTEX && !isManualContract && (
                        <button
                          className={`nav-link vtex-company-nav-link${
                            activeTab === 5 ? "active" : ""
                          }`}
                          onClick={(e) => handleNavigationItemClick(5, e)}
                        >
                          {t["Contract Signature"]}
                        </button>
                      )}
                      {isVTEX && isManualContract && (
                        <button
                          className={`nav-link vtex-company-nav-link${
                            activeTab === 5 ? "active" : ""
                          }`}
                          onClick={(e) => handleNavigationItemClick(5, e)}
                        >
                          {t["Manual Contract"]}
                        </button>
                      )}
                    </div>
                  </nav>
                  <div className="tab-content" id="nav-tabContent">
                    <div
                      className={`tab-pane fade overflow-auto show active`}
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="nav-home-tab"
                      tabIndex="0"
                    >
                      {activeTab === 0 &&
                        (!isVTEX ? (
                          <General
                            disabled={disableInputs}
                            context={context}
                            company_id={company_id}
                            stateList={stateList}
                            setStateList={setStateList}
                            counryList={counryList}
                            setCounryList={setCounryList}
                            currencyList={currencyList}
                            setCurrencyList={setCurrencyList}
                            mailTemplateList={mailTemplateList}
                          />
                        ) : (
                          <VtexGeneral
                            disabled={disableInputs}
                            context={context}
                            company_id={company_id}
                            stateList={stateList}
                            setStateList={setStateList}
                            counryList={counryList}
                            setCounryList={setCounryList}
                            currencyList={currencyList}
                            setCurrencyList={setCurrencyList}
                            mailTemplateList={mailTemplateList}
                            billingCountryList={billingCountryList}
                            setBillingCountryList={setBillingCountryList}
                            billingGovernateList={billingGovernateList}
                            setBillingGovernateList={setBillingGovernateList}
                            billingWilayatList={billingWilayatList}
                            setBillingWilayatList={setBillingWilayatList}
                            billingCityList={billingCityList}
                            setBillingCityList={setBillingCityList}
                            billingAreaList={billingAreaList}
                            setBillingAreaList={setBillingAreaList}
                            billingZipList={billingZipList}
                            setBillingZipList={setBillingZipList}
                            pickupCountryList={pickupCountryList}
                            setPickupCountryList={setPickupCountryList}
                            pickupGovernateList={pickupGovernateList}
                            setPickupGovernateList={setPickupGovernateList}
                            pickupWilayatList={pickupWilayatList}
                            setPickupWilayatList={setPickupWilayatList}
                            pickupCityList={pickupCityList}
                            setPickupCityList={setPickupCityList}
                            pickupAreaList={pickupAreaList}
                            setPickupAreaList={setPickupAreaList}
                            pickupZipList={pickupZipList}
                            setPickupZipList={setPickupZipList}
                          />
                        ))}
                      {activeTab === 1 && (
                        <FieldArray
                          name="bank_ids"
                          render={({ ...args }) => {
                            return isVTEX ? (
                              <BankInformation
                                {...args}
                                disabled={disableInputs}
                                context={context}
                                company_id={company_id}
                                bankList={bankList}
                              />
                            ) : (
                              <BankAccountCR
                                {...args}
                                disabled={disableInputs}
                                context={context}
                                company_id={company_id}
                                bankList={bankList}
                              />
                            );
                          }}
                        />
                      )}
                      {activeTab === 2 && (
                        <FieldArray
                          name="bank_ids"
                          render={({ ...args }) => {
                            return (
                              <Documents
                                {...args}
                                disabled={disableInputs}
                                context={context}
                                company_id={company_id}
                                bankList={bankList}
                              />
                            );
                          }}
                        />
                      )}
                      {activeTab === 3 && (
                        <VtexIntegration
                          disabled={disableInputs}
                          isVtexInvitationConnected={isVtexInvitationConnected}
                          refetchData={fetchCompanyDetails}
                        />
                      )}
                      {activeTab === 4 && (
                        <FieldArray
                          name="associated_user_ids"
                          render={({ ...args }) => {
                            return (
                              <ContactDetails
                                {...args}
                                disabled={disableInputs}
                                refetchData={fetchCompanyDetails}
                              />
                            );
                          }}
                        />
                      )}
                      {activeTab === 5 && (
                        <>
                          {!isManualContract && (
                            <SignatureComponent
                              base64Signature={values.digital_signature}
                              disabled={disableInputs}
                              setFieldValue={setFieldValue}
                            />
                          )}
                          {isManualContract && (
                            <FieldArray
                              name="manual_contract_id"
                              render={({ ...args }) => {
                                return (
                                  <ManualContract
                                    {...args}
                                    disabled={disableInputs}
                                    refetchData={fetchCompanyDetails}
                                  />
                                );
                              }}
                            />
                          )}
                        </>
                      )}

                      {/* <div
                    className={`tab-pane fade ${
                      activeTab === 2 ? "show active" : ""
                    }`}
                    id="nav-profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                    tabIndex="2"
                  >
                    <Branches
                      disableInputs={disableInputs}
                      context={context}
                      company_id={company_id}
                    />
                  </div> */}
                    </div>
                  </div>
                  {!disableInputs && (
                    <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                  )}
                </LoaderWrapper>
              </FormContainer>
            </div>
            {/* <ErrorFocus /> */}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddNewCompany;
